import { Link } from '@sitecore-jss/sitecore-jss-nextjs';
import { NavItem } from '../Header/MegaNavigation/MegaNavigation.types';
import styles from './AccordionItem.module.scss';

export interface AccordionItemProps {
  item: NavItem;
  keyPrefix: string;
  level: number;
  index: number;
  openItems: Record<string, boolean>;
  toggleOpen: (key: string) => void;
}

export const AccordionItem = ({
  item,
  keyPrefix,
  level,
  index,
  openItems,
  toggleOpen,
}: AccordionItemProps) => {
  const key = `${keyPrefix}-${item.id}-${index}`;
  const isOpen = openItems[key];
  const children = item.fields?.items ?? [];
  const title = item.fields?.title?.value || item.displayName || item.name;

  return (
    <div key={key} aria-label={`accordion__title--${title}`}>
      <button
        id={`side-navigation-top-item-${title}`}
        className={styles['accordion-title']}
        aria-expanded={isOpen}
        onClick={() => toggleOpen(key)}
      >
        <div className={`${styles.title} ${styles[`indent-level-${level}`]}`}>{title}</div>
        <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`} />
      </button>
      <div
        id={`side-navigation-item-${key}`}
        className={`${styles.content} ${!isOpen ? styles['hidden'] : ''}`}
      >
        {children.map((child: NavItem, i: number) => {
          const childKey = `${key}-child-${i}`;
          const childTitle = child.fields?.title?.value || child.displayName || child.name;

          if (child.fields?.link?.value?.href) {
            return (
              <Link field={child.fields.link} key={childKey} className={styles.link}>
                <div
                  id={`side-navigation-link-item-${childTitle}`}
                  className={`${styles.text} ${styles[`indent-level-${level}`]}`}
                >
                  {childTitle}
                </div>
              </Link>
            );
          }

          return (
            <AccordionItem
              item={child}
              keyPrefix={key}
              level={level + 1}
              index={i}
              openItems={openItems}
              toggleOpen={toggleOpen}
              key={childKey}
            />
          );
        })}
      </div>
    </div>
  );
};
